module.exports = __webpack_public_path__ + "static/img/investor1.d331294e.png";